<template>
  <div>
    <transition :name="animations.fadeIn.name" :leave-active-class="animations.fadeIn.leave" :enter-active-class="animations.fadeIn.enter">
      <div class="card user-card" v-if="ready">
        <div class="card-body">
          <div class="online-user" style="margin-bottom:20px;">
            <h5 class="font-primary f-18 mb-0">Ihr Ansprechpartner</h5>
          </div>
          <div class="user-card-image">
            <img class="img-fluid rounded-circle image-radius" :src="avatar" alt="" />
          </div>
          <div class="user-deatils text-center">
            <h5>{{ themaUser.first_name }} {{ themaUser.last_name }}</h5>
            <h6>Zuständigkeit: {{ show_themen }}</h6>
          </div>
          <div class="user-badge text-center">
            <a :href="'mailto:' + themaUser.email" class="badge badge-pill badge-light"><feather type="mail" size="20px"></feather></a>
            <a :href="'phone:' + themaUser.telefon" class="badge badge-pill badge-light"><feather type="phone-outgoing" size="20px"></feather></a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Ansprechpartner",
  props: ["show_themen"],
  components: {},
  computed: {
    ...mapGetters({
      toasts: "app/toasts",
      animations: "app/animations",
      themen: "app/themen",
    }),
  },
  data() {
    return {
      avatar: null,
      themaUser: null,
      loading: {
        themen: false,
      },
      ready: false,
    };
  },
  async created() {
    try {
      this.loading.themen = true;
      await this.$store.dispatch("app/apiGetThemen");
      if (!this.themen.length) return;
      await this.resolveThemenRelation();
    } catch (error) {
      console.log(error);
      this.$toasted.show("Fehler beim Laden der Themen", this.toasts.failure);
    } finally {
      this.loading.themen = false;
    }
  },
  methods: {
    async resolveThemenRelation() {
      const filterThemen = {
        filter: {
          name: this.show_themen,
        },
      };

      let themaId = null;
      try {
        const response = await this.$directus.getItems("ansprechpartner_themen", filterThemen);
        themaId = response.data[0].id;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Beziehung ansprechpartner_themen", this.toasts.failure);
      }

      try {
        const filter = {
          filter: {
            themen_id: themaId,
          },
        };
        const response = await this.$directus.getItems("ansprechpartner_themen_user", filter);
        const responseUser = await this.$directus.getItem("directus_users", response.data[0].user_id);
        this.themaUser = responseUser.data;
        if (responseUser.data.avatar) {
          await this.getUserAvatar(responseUser.data.avatar);
        }
        if (!responseUser.data.avatar) this.avatar = "https://directus.iam-design.de/public/iam-test/assets/2lf5iebeuni8s0sc";
        await this.getContactData(responseUser.data.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden des Thema Benutzers", this.toasts.failure);
      } finally {
        this.ready = true;
      }
    },
    async getUserAvatar(id) {
      try {
        const response = await this.$directus.getItem("directus_files", id);
        this.avatar = response.data.data.thumbnails[3].url;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden des Benutzeravatars", this.toasts.failure);
      }
    },
    async getContactData(userId) {
      const filter = {
        filter: {
          ansprechpartner: userId,
        },
      };
      try {
        const response = await this.$directus.getItems("ansprechpartner", filter);
        this.themaUser.telefon = response.data[0].telefon;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Kontaktdaten", this.toasts.failure);
      }
    },
  },
};
</script>

<style scoped>
.user-card .user-badge .badge {
  margin-bottom: 0px;
}

.badge svg {
  width: inherit !important;
  height: inherit !important;
}
</style>
